import { request } from '@/api/http';

/**
 * 获取统计信息
 */
export var count = function count() {
  return request({
    url: '/api/dashboard/count',
    method: 'get'
  });
};
export function getDashboardData() {
  return request({
    url: '/api/v5/dashboard/data',
    method: 'get'
  });
}

/**
 * 获取等办列表
 * @returns
 */
export function getTodoList() {
  return request({
    url: '/api/v5/sys/notify/my/my?page=1&size=6',
    method: 'get'
  });
}